/**
 * Protection d'un document Canvas précis.
 *
 * Un remplacement, une sauvegarde ou un export ne doit s'interdire que si le
 * résident que le geste cible est réellement utilisé. Les compteurs du registre
 * sont la seule autorité : une autre conversation peut continuer à écrire dans
 * son propre éditeur sans rendre ce document indisponible.
 */

import * as React from 'react';
import { canvasDocumentRuntime } from './canvasDocumentRuntime';
import { isCanvasSessionProtected } from './canvasSessionRegistry';

/** Lecture impérative de la protection du résident exact, pour les gestes async. */
export function isCanvasSessionProtectedByWork(conversationId: string): boolean {
  const session = canvasDocumentRuntime.getSessionsSnapshot().sessions.find(
    (candidate) => candidate.conversationId === conversationId,
  ) ?? null;
  return isCanvasSessionProtected(session);
}

/** Projection réactive de la même protection, pour les commandes du résident. */
export function useCanvasSessionProtectedByWork(conversationId: string | null): boolean {
  return React.useSyncExternalStore(
    (notify) => canvasDocumentRuntime.subscribeSessions(() => notify()),
    () => conversationId !== null && isCanvasSessionProtectedByWork(conversationId),
    () => false,
  );
}

/** Une commande destructive ne doit jamais remplacer un document en activité. */
export const CANVAS_REPLACEMENT_BLOCKED_MESSAGE =
  "Hector rédige dans ce document — le remplacer maintenant supprimerait ce qu'il écrit. "
  + "Arrête d'abord la rédaction depuis le canvas, puis réessaie.";

/** Complément d'infobulle pour les commandes qui remplacent le document. */
export const CANVAS_REPLACEMENT_BLOCKED_HINT =
  ' — indisponible pendant la rédaction : le document en cours serait supprimé';

/** Complément d'infobulle pour les sorties qui produiraient un DOCX incomplet. */
export const CANVAS_EXPORT_BLOCKED_HINT =
  ' · indisponible pendant la rédaction. Le document serait incomplet.';
